/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

import { VApplication } from "../../../application";
import { GET_PRINT_SUMMARY_REPORT } from "../graphql/getPrintSummaryReport.query";
import { GET_PRESENTATIONS } from "../graphql/getPresentations.query";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();

  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPrintSummaryReportMethods extends IPluginMethodMap {
  getPrintSummaryReport(args: any): Promise<any>;
}

export class PrintSummaryReportService implements IAgentPlugin {
  readonly methods: IPrintSummaryReportMethods;

  constructor() {
    this.methods = {
      getPrintSummaryReport: this.getPrintSummaryReport.bind(this),
    };
  }

  async getPrintSummaryReport(args: any): Promise<any> {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (!client) {
        throw new Error("GraphQL client is not available");
      }

      let presentationId = args?.presentation;

      console.log("Print summary received args ==>", args);
      console.log("Print summary received presentation ==>", presentationId);

      /*
       * Use the first active presentation when the container
       * does not send a selected presentation ID.
       */
      if (
        presentationId === "" ||
        presentationId === null ||
        presentationId === undefined
      ) {
        const presentationResponse = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: {
              status: {
                eq: "active",
              },
            },
          },
          fetchPolicy: "network-only",
        });

        presentationId =
          presentationResponse?.data?.getPresentations?.content?.[0]?.id;
      }

      if (!presentationId) {
        throw new Error("No active presentation found");
      }

      const filter = {
        presentation: {
          eq: presentationId,
        },
      };

      console.log("Print summary filter ==>", filter);

      const response = await client.query({
        query: GET_PRINT_SUMMARY_REPORT,
        variables: {
          filter,
        },
        fetchPolicy: "network-only",
      });

      console.log("Print summary response ==>", response);

      return response;
    } catch (err: any) {
      console.error("Print summary service error ==>", err);

      const displayError =
        Array.isArray(err?.graphQLErrors) &&
        err.graphQLErrors.find(
          (item: any) => item?.extensions?.display_message,
        );

      if (displayError?.extensions?.display_message) {
        throw new Error(displayError.extensions.display_message);
      }

      throw err;
    }
  }
}
